import { CheckCircleTwoTone } from "@ant-design/icons";
import { Empty, Typography, theme } from "antd";
import { VyneTable } from "@vyne-shared/components/vyneTable/VyneTable";
import type { BulkRequestSummaryItem } from "api/responses";
import type { BulkRequestSummaryRecord } from "api/clients/useBulkRequestStatusQuery";
import type { ColumnsType } from "antd/es/table";

const { Title } = Typography;
const { useToken } = theme;

interface BulkStatusCardProps {
    readonly record: BulkRequestSummaryRecord;
}

const columns: ColumnsType<BulkRequestSummaryItem> = [
    {
        title: "Patient Name",
        dataIndex: "patientName",
    },
    {
        title: "Error",
        dataIndex: "error",
    },
];

/** Displays errors for a particular bulk request. */
export const BulkStatusErrorLog = ({ record }: BulkStatusCardProps) => (
    <div className="bulk-status-card-error-log">
        <Title level={4}>Error Log</Title>
        <VyneTable
            name={`Batch Request ${record.batchId} Status Error Log on ${record.date}`}
            columns={columns}
            dataSource={record.errorItems}
            rowKey={(x: BulkRequestSummaryItem) => `${x.id}`}
            pagination={{ hideOnSinglePage: true, pageSize: 10 }}
            locale={{ emptyText: <EmptyText /> }}
        />
    </div>
);

const EmptyText = () => {
    const { token } = useToken();

    return (
        <Empty
            description="No errors!"
            image={<CheckCircleTwoTone twoToneColor={token.colorSuccess} />}
            styles={{ image: { fontSize: 48, opacity: 0.5 } }}
        />
    );
};
